/* Theme-driven breadcrumb bar chrome. Item/separator/current styling comes
   from Astryx's Breadcrumbs component itself; this file only styles the bar,
   using Astryx neutral-theme tokens, so it must live inside an Astryx
   <Theme> scope. */
.bar {
  padding: var(--spacing-2) var(--spacing-6);
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
}

@media (max-width: 900px) {
  .bar {
    padding-left: var(--spacing-5);
    padding-right: var(--spacing-5);
    flex-direction: column;
    align-items: flex-start;
  }
}
